'use client';
import { DEFAULT_LOCALE, isServer } from '../constants.js';

const FRACTION_DIGITS_FOR_PRICE = 2;
/**
 * Formats a price amount according to the specified options.
 * @param {number} amount - The price amount in cents.
 * @param {Object} [options] - The formatting options.
 * @param {string} [options.currency='USD'] - The currency code.
 * @param {boolean} [options.keepFractionDigitsForZeroCents] - Whether to keep fraction digits when cents are zero.
 * @returns {string} The formatted price string.
 */
const formatPrice = (amount, options = {}) => {
    const { currency = 'USD', keepFractionDigitsForZeroCents } = options;
    let locale = DEFAULT_LOCALE;
    if (!isServer && window?.navigator?.language != null) {
        locale = window.navigator.language;
    }
    const centsExist = amount % 100 !== 0;
    const formatterOptions = {
        currency,
        style: 'currency',
        maximumFractionDigits: FRACTION_DIGITS_FOR_PRICE,
        minimumFractionDigits: centsExist || keepFractionDigitsForZeroCents
            ? FRACTION_DIGITS_FOR_PRICE
            : 0,
    };
    const formatter = new Intl.NumberFormat(locale, formatterOptions);
    return formatter.format(amount / 100);
};

export { formatPrice };
//# sourceMappingURL=format-price.js.map
